<template>
    <div>
        <div class="row">
            <div class="col-2">
                <div class="light-andon" :class="lightClass">
                    <!--          <img slot="logo" :class="lightClass" />-->
                    <click-assistant :callback="headerLogoClick" class="w-100 h-100">
                        <img src="@/assets/images/SE_Logo_White_RGB.png"
                             class="logo-andon position-relative"/>
                    </click-assistant>

                </div>
            </div>

            <div class="col-5 text-truncate" style="height: 100%">
                <div class="row header-title mt-4">
                    <div class="col-4 text-right">
                        工作中心:
                    </div>
                    <div class="col-8">
                        {{ workCenter }}
                    </div>
                </div>
                <div class="row header-title mt-2">
                    <div class="col-4 text-right">
                        工位:
                    </div>
                    <div class="col-8" @click="openStationDialog">
                        {{ station }}
                        <i class="fa-solid fa-pen-to-square"></i>
                    </div>
                </div>
            </div>

      <div class="col-3">
        <div class="right-menu row">
          <div
              class="col d-flex flex-column"
              style="width: 180px;height: 50px;margin-top: 20px"
              @click="$router.push('/sithMes/prd/sithMesPrdOperationUserList')"
          >
            <font-awesome-icon
                :icon="['fas', 'exchange-alt']"
                style="width: 40px;height: 30px;color: white;margin: auto"
            ></font-awesome-icon>
            <span class="header-title">
              切换工序
            </span>
          </div>
          <div class="col">
            <el-dropdown trigger="click">
              <font-awesome-icon
                  :icon="['fas', 'user']"
                  style="width: 60px;height: 40px;margin: 25px 0 0 10px"
                  :class="userStatusClass"
              ></font-awesome-icon>

              <el-dropdown-menu slot="dropdown">
                <span style="display:block;" @click="show = true">
                  <el-dropdown-item>
                    <router-link to="/em/emUserCenter" class="dropdown-item">
                      <i class="fa fa-user fa-lg"></i>
                      {{ $t("app.profile") }}
                    </router-link>
                  </el-dropdown-item>
                </span>

                <span style="display:block;">
                  <el-dropdown-item divided>
                    <a
                        class="dropdown-item"
                        href="page-login.html"
                        v-on:click="logout"
                    >
                      <i class="fa fa-sign-out-alt fa-lg"></i>
                      {{ $t("app.logout") }}
                    </a>
                  </el-dropdown-item>
                </span>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <el-tooltip></el-tooltip>
        </div>
      </div>
      <div class="col-2" @click="refreshUserStatus">
        <el-tooltip
            :content="userList"
            placement="bottom"
            effect="light"
        >
          <el-alert class="user-label" :title="userList" type="info" :closable="false"
                    v-loading="loading"
                    element-loading-background="rgba(0, 0, 0, 0)">
          </el-alert>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import ClickAssistant from "@/components/echarts-part/CalendarShift/cells/stuffs/ClickAssistant";
import screenfull from "screenfull";

const classMapping = {
    green: {
        value: "",
        lightClass: "light_green"
    },
    yellow: {
        value: "",
        lightClass: "light_yellow"
    },
    red: {
        value: "",
        lightClass: "light_red"
    }
};
const userMapping = {
    rest: {
        value: "离岗",
        userClass: "user_rest"
    },
    working: {
        value: "在岗",
        userClass: "user_working"
    }
};

export default {
    name: "andon-header",
    components: {ClickAssistant},
    props: ["workCenter", "station", "operatorStatus", "value"],
    data: function () {
        return {
            lightValue: this.value,
            color: "green",
            userValue: this.operatorStatus,
            userList: "离岗",
            userStatus: "rest",
            clickTimes: 0,
            loading: true,
            headerLogoClick: {
                click: () => {
                    this.switchScreenFull();
                },
                dbClick: () => {
                    this.$message({
                        message: "开始刷新页面",
                        type: "info"
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 300);
                }
            }
        };
    },

    methods: {
        logout() {
            this.$authentication.logout(this.$store);
        },
        switchScreenFull() {
            screenfull.toggle();
        },
        refreshUserStatus() {
            this.$emit('needFresh');
        },
        openStationDialog() {
            this.$emit('switchMstLocation');
        }
    },
    watch: {
        value: function (newValue) {
            if (newValue === 0) {
                this.lightValue = 0;
                this.color = "red";
            } else if (newValue > 1) {
                this.lightValue = 2;
                this.color = "yellow";
            } else if (newValue === 1) {
                this.lightValue = 1;
                this.color = "green";
            }
        },
        operatorStatus: function (newValue) {
            if (newValue === 1) {
                this.userValue = 1;
                this.userStatus = "working";
            } else {
                this.userValue = 0;
                this.userStatus = "rest";
            }
        }
    },
    computed: {
        lightClass: function () {
            return classMapping[this.color].lightClass;
        },
        userStatusClass: function () {
            return userMapping[this.userStatus].userClass;
        }
    }
};
</script>

<style lang="scss" scoped>
.light-andon {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    margin: 10px;
}

.light_green {
    background: #73dc73 !important;
}

.light_yellow {
    background: yellow !important;
}

.light_red {
    background: red !important;
}

.logo-andon {
    width: 50px;
    height: 30px;
    z-index: 9999;
    top: 25px;
    left: 15px;
}

.el-alert__title {
    font-size: 18px !important;
}

.el-alert--info.is-light {
    margin: auto;
    background-color: #8a00e5;
    font-size: 25px !important;
    margin-left: -20px !important;
}

.right-menu {
    float: right;
    height: 100%;
    line-height: 60px;
}

.header-title {
    color: whitesmoke;
    font-size: 18px;
    font-weight: bold;
    margin: auto;
}

.user-label {
    color: whitesmoke !important;
    // font-size: 18px !important;
    font-weight: bold !important;
    margin: auto !important;
    position: absolute;
    top: 30%;
    height: 55px;
    overflow: hidden;
    // max-width: 10px;
    // white-space: nowrap;
    text-overflow: ellipsis;
}

.user_working {
    color: #3de463;
}

.user_rest {
    color: whitesmoke;
}
</style>
<style>
.el-alert__title {
    color: whitesmoke !important;
    font-size: 18px !important;
    font-weight: bold;
    margin: auto;
    position: absolute;
    top: 30%;
    height: 55px;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
